var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditcardWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.74521e-05 19.6911C-0.018625 20.4616 0.268651 21.2082 0.798964 21.7676C1.32928 22.3269 2.05948 22.6536 2.82994 22.6761H28.6709C29.4409 22.6528 30.1701 22.325 30.6987 21.7646C31.2272 21.2042 31.5117 20.4571 31.4899 19.6871V8.30307H-5.74521e-05V19.6911ZM1.36894 9.75107H30.1209V19.6911C30.1317 20.0873 29.9853 20.4716 29.7136 20.7602C29.4419 21.0487 29.0671 21.218 28.6709 21.2311H2.82994C2.43304 21.2175 2.05738 21.0484 1.78405 20.7603C1.51072 20.4722 1.36162 20.0881 1.36894 19.6911V9.75107ZM28.5439 12.8621H16.0619V14.3101H28.5439V12.8621ZM28.6709 0.976074H2.82994C2.0594 0.99728 1.32872 1.32324 0.798191 1.88246C0.267658 2.44167 -0.0194149 3.18848 -5.74521e-05 3.95907V6.06907H31.4899V3.95907C31.5107 3.18996 31.2255 2.44403 30.6971 1.88483C30.1686 1.32564 29.44 0.998829 28.6709 0.976074V0.976074ZM30.1209 4.62107H1.36894V3.95907C1.36294 3.56276 1.51259 3.1799 1.78576 2.89271C2.05893 2.60552 2.43383 2.4369 2.82994 2.42307H28.6709C29.0663 2.43614 29.4406 2.60489 29.7122 2.89257C29.9837 3.18025 30.1307 3.56357 30.1209 3.95907V4.62107Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.429 4.91113H0V9.14213H31.429V4.91113Z",
    fill: "#B3B3B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcardWhiteIcon);
export default __webpack_public_path__ + "static/media/creditcard-white-icon.5e2d4037.svg";
export { ForwardRef as ReactComponent };